import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../lib/authApi";

const AuthGate: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [authed, setAuthed] = useState(isAuthenticated());

  useEffect(() => {
    const onExpired = () => setAuthed(false);
    window.addEventListener("pulse-auth-expired", onExpired);
    return () => window.removeEventListener("pulse-auth-expired", onExpired);
  }, []);

  if (!authed) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AuthGate;
